module.exports = __webpack_public_path__ + "static/practice-mgmt-banner-bd0b02fda6bfd6d4aa27fff96265463c.jpg";